import { connect } from 'react-redux';
import {
	getWebFormConfiguration,
	getIncidentTypes,
	getCategories,
	onSubmit,
	resetMeta,
	resetPage
} from '../../actions/WebFormDetailPage';
import WebFormDetailPage from './WebFormDetailPage';

const mapsStateToProps = state => ({
	pageProps: state.webFormDetailPageReducer
});

const mapsDispatchToProps = dispatch => ({
	getWebFormConfiguration() {
		dispatch(getWebFormConfiguration());
	},
	getIncidentTypes() {
		dispatch(getIncidentTypes());
	},
	getCategories() {
		dispatch(getCategories());
	},
	onSubmit(fields) {
		dispatch(onSubmit(fields));
	},
	resetMeta() {
		dispatch(resetMeta());
	},
	resetPage() {
		dispatch(resetPage());
	}
});
export default connect(
	mapsStateToProps,
	mapsDispatchToProps
)(WebFormDetailPage);

